import React from "react";
import "../styles/skeleton.css";

const Skl: React.FC<{ className?: string; style?: React.CSSProperties }> = ({
  className = "",
  style,
}) => <div className={`skeleton ${className}`} style={style} />;

const PropertyDetailSkeleton: React.FC = () => (
  <div>
    <div className="container pt-4">
      <Skl style={{ width: "250px", height: "18px", marginBottom: "24px" }} />

      <Skl style={{ width: "400px", height: "32px", marginBottom: "8px" }} />

      <Skl style={{ width: "280px", height: "16px", marginBottom: "24px" }} />

      <div className="row g-2 mb-4">
        <div className="col-12 col-md-8">
          <Skl
            style={{
              width: "100%",
              height: "400px",
              borderRadius: "12px",
            }}
          />
        </div>
        <div className="col-12 col-md-4">
          <div className="d-flex flex-column gap-2 h-100">
            <Skl
              style={{
                width: "100%",
                height: "calc(50% - 4px)",
                borderRadius: "12px",
              }}
            />
            <Skl
              style={{
                width: "100%",
                height: "calc(50% - 4px)",
                borderRadius: "12px",
              }}
            />
          </div>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-12 col-lg-8">
          <div className="bg-white rounded-3 border p-4 shadow-sm mb-4">
            <Skl
              style={{
                width: "200px",
                height: "16px",
                marginBottom: "20px",
              }}
            />
            <div className="row g-3 row-cols-2 row-cols-sm-4 text-center">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="d-flex flex-column align-items-center gap-2">
                  <Skl
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                    }}
                  />
                  <Skl style={{ width: "50%", height: "14px" }} />
                  <Skl style={{ width: "70%", height: "12px" }} />
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-3 border p-4 shadow-sm mb-4">
            <Skl
              style={{
                width: "180px",
                height: "18px",
                marginBottom: "16px",
              }}
            />
            <div>
              {[1, 2, 3, 4].map((i) => (
                <Skl
                  key={i}
                  style={{
                    width: i % 2 === 0 ? "85%" : "100%",
                    height: "14px",
                    marginBottom: "10px",
                  }}
                />
              ))}
            </div>
          </div>

          <div className="bg-white rounded-3 border p-4 shadow-sm mb-4">
            <Skl
              style={{
                width: "120px",
                height: "18px",
                marginBottom: "16px",
              }}
            />
            <Skl
              style={{
                width: "100%",
                height: "300px",
                borderRadius: "12px",
              }}
            />
          </div>
        </div>

        <div className="col-12 col-lg-4">
          <div
            className="sticky-top"
            style={{ top: "100px", zIndex: 9 }}
          >
            <div className="bg-white rounded-3 border p-4 shadow-sm mb-4">
              <Skl
                style={{
                  width: "100px",
                  height: "14px",
                  marginBottom: "12px",
                }}
              />

              <Skl
                style={{
                  width: "60%",
                  height: "32px",
                  marginBottom: "20px",
                }}
              />

              <div className="row g-2 border-bottom pb-4 mb-4">
                <div className="col-6">
                  <Skl style={{ width: "100%", height: "14px" }} />
                </div>
                <div className="col-6">
                  <Skl style={{ width: "100%", height: "14px" }} />
                </div>
              </div>

              <Skl
                style={{
                  width: "80%",
                  height: "16px",
                  marginBottom: "16px",
                }}
              />

              {[1, 2, 3].map((i) => (
                <Skl
                  key={i}
                  style={{
                    width: "100%",
                    height: "42px",
                    marginBottom: "8px",
                    borderRadius: "6px",
                  }}
                />
              ))}

              <Skl
                style={{
                  width: "100%",
                  height: "44px",
                  marginTop: "4px",
                  borderRadius: "6px",
                }}
              />

              <div className="text-center my-3">
                <Skl
                  style={{
                    width: "40px",
                    height: "16px",
                    margin: "0 auto",
                  }}
                />
              </div>

              <Skl
                style={{
                  width: "100%",
                  height: "48px",
                  borderRadius: "6px",
                }}
              />
            </div>

            <div className="bg-white rounded-3 border p-3 shadow-sm d-flex align-items-center gap-3">
              <Skl
                style={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "50%",
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1 }}>
                <Skl
                  style={{
                    width: "70%",
                    height: "16px",
                    marginBottom: "4px",
                  }}
                />
                <Skl
                  style={{
                    width: "50%",
                    height: "12px",
                    marginBottom: "2px",
                  }}
                />
                <Skl style={{ width: "35%", height: "10px" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PropertyDetailSkeleton;
